import React from 'react';
import DefaultLayout from "../components/layouts/DefaultLayout"
import { useState, useEffect } from "react";
import { connect } from 'react-redux'
import { useSelector} from 'react-redux';
import darkClass from '../util/theme'
import {AirdropABI} from '../web3/abis/airdrop';
import airdrops from '../data/airdrops';
import Web3 from 'web3';
import ConnectBtn from '../components/layouts/header/ConnectBtn';

const compareCanClaim =  function(obj1, obj2) {
    const a = !!obj1.canClaim;
    const b = !!obj2.canClaim;
    if (Number(a) > Number(b)) {
      return -1;
    }
    if (Number(a) < Number(b)) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }

const tokenAddressBankX = '0x2147F5c02c2869E8C2d8F86471d3d7500355d698';
const tokenSymbolBankX = 'BankX';
const tokenImageBankX = 'https://uc85468ed6bdd7c424890bae0cbd.previews.dropboxusercontent.com/p/thumb/AB6j9VuEG7CuI9sBwql_H4qV-1Nk_N8QkefyaVv62yqZw46ksCPjUE-IOVPWIfccw93QlIBnFotE51hmSeT6EaoMI0VkHuq6FkD3BWURiTPmYZjZEJ9jkvjSPjchav7fKKIiPaiGTUUYFsX2GsVskW0SsJE90sW3TT93H2hMn1GFnZQG4esVK2YvEqYjkOoPZBu5II8gtTPHTqj_0RsTIWj_dmnj_fEoapdvDXTBLxkdjTr8eQ8Rut7JofTxyfg31gin7IhN3avxVzJyW5emDRJEkxo7DmaZI4WC5Z9-GBqux4Sh--E0WlPpfj0JAhiExvedJ8scqpDcqHeB06uyBB40IykJ89IQD-q09c-rYqFN_9aGRda58aWeaZjdLkfaBXXrGmnAtuOmcbg44DKoHyKxLUl8gpxQNvR68jS0oHpmig/p.jpeg';
const tokenAddressXSD = '0x93Abe713002526D4cE708f890139f19313012f95';
const tokenSymbolXSD = 'XSD';
const tokenImageXSD = 'https://uc8feecd3c830404c6fb662c2412.previews.dropboxusercontent.com/p/thumb/AB7wKKT05ofpMApyRCcX8pxVBepQChlG-K9GfAGLdbp9ZG77ACLoiMiDkGoub0iFHFigH8_CVEiwhx55fy1jhRyMQqH-AzD0bEvKWCk_tFS14IQvHdRtu3G4CCVAt00eHuA198kQYwaHipVBASiscfFo2od84XGcp0XwC5WoP7PNPVnpl4M8wWVn4FqzJW3rS6CAZxhI66ehYtqJDNJE__VY5sgtfSInjp03BuTrqPB-EMnEvvA52f7LL6Z-k78UZgTW7WPR6y2nhx4PamYV-BjauoWHOOXdbluqDp-laPRzTDloN4CM0nZmB152uVqMJLH6yEw0XnQ5Oj9hSX9BcbbW4XC5JTodcjsJDhVUIFUEpetES9vVMkVu_G_hQOAejtvY3Dbw8JN8OonzuhHl5kI5jUpSFGI4FvmEj4YVevG9uw/p.jpeg';
const tokenDecimals = 18;



function Home(props) {
    const [loading,setLoading]=useState(false)
    const {theme} = useSelector(state => state.themeReducer);
    const {web3Provider,address} = useSelector(state => state.web3Reducer);
    const {chainType} = useSelector(state => state.chainTypeReducer);
    const [data, setData] = useState([]);
    const [claiming, setClaiming] = useState({});
    const [loadingData, setLoadingData] = useState(false);

    const AIRDROP_CONTRACTS = {
        'APP_AIRDROP_CONTRACT_AVALANCHE': '0x75F9c424de79fb7503CD49F5E8Cd8d15505BF1C3'
    };

    useEffect(()=> {
        if (web3Provider) {
            web3Provider.eth.getAccounts().then();
        }
    }, [web3Provider]);

    function loadAirdrops(address, chainType) {
        address = Web3.utils.toChecksumAddress(address);
        const contract = new web3Provider.eth.Contract(
            AirdropABI,
            AIRDROP_CONTRACTS[`APP_AIRDROP_CONTRACT_${chainType.toUpperCase()}`],
        );
        console.log("=== contract: ", contract);
        const drops = airdrops.filter(a=>a[chainType].deadline > (Date.now()/1000)).map((airdrop)=> {
            airdrop =  airdrop[chainType];
            airdrop.canClaim = false;
            airdrop.amount = "0";
            airdrop.proof = [];
            if (airdrop.name.search(/xsd/i) >= 0) {
                airdrop.ui_name = "XSD";
            }
            else if (airdrop.name.search(/bankx/i) >= 0) {
                airdrop.ui_name = "BankX";
            }
            else {
                airdrop.ui_name = "Unknown";
            }
            if (airdrop.receivers) {
                airdrop.amount = airdrop.receivers[address] ? airdrop.receivers[address].amount : "0";
                airdrop.proof = airdrop.receivers[address] ? airdrop.receivers[address].proof : [];
            }
            console.log("=== airdrop.amount", airdrop.amount);
            if (airdrop.amount !== "0") {
                setLoadingData(true);
                return contract.methods.canClaim(address, airdrop.name, airdrop.token, airdrop.amount, airdrop.merkleRoot, airdrop.proof).call()
                .then(result=>{
                    airdrop.canClaim = true;
                    return airdrop
                })
                .catch(error=>{
                    if(error.message.includes('Already claimed')) {
                        airdrop.claimed = true;
                    }
                    airdrop.canClaim = false;
                    return airdrop;
                });
            }
            return airdrop;
        });
        Promise.all(drops).then(result=>{
            setLoadingData(false);
            setData([...result]);
        });
    }

    console.log("==== chainType: ", chainType)
    console.log("==== address", address)


    useEffect(()=> {
        if (chainType && address && web3Provider) {
            console.log("==== loadAirdrops")
            loadAirdrops(address, chainType);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address, chainType, web3Provider]);

    async function handleClaim(airdrop){
        const contract = new web3Provider.eth.Contract(
            AirdropABI,
            AIRDROP_CONTRACTS[`APP_AIRDROP_CONTRACT_${chainType.toUpperCase()}`],
        );
        
        setLoading(true);
        setClaiming({ [airdrop.name]: true });
        contract.methods.claim(airdrop.name, airdrop.token, airdrop.amount, airdrop.merkleRoot, airdrop.proof).send({ from:address }).then( (res) => {
          setLoading(false);
          setClaiming({});
          loadAirdrops(address, chainType);
        }).catch((error) => {
            setLoading(false);
            setClaiming({});
          })
    }
    async function addTokenFunction(airdrop_name) {
        let tokenAddress;
        let tokenSymbol;
        let tokenImage;
        switch (airdrop_name) {
            case 'XSD':
                tokenAddress = tokenAddressXSD;
                tokenSymbol = tokenSymbolXSD;
                tokenImage = tokenImageXSD;
                break;
            case 'BankX':
                tokenAddress = tokenAddressBankX;
                tokenSymbol = tokenSymbolBankX;
                tokenImage = tokenImageBankX;
                break;
            default:
                console.log("Airdrop is not detected.")
        }

        try {
          const wasAdded = await window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
              type: 'ERC20', 
              options: {
                address: tokenAddress, 
                symbol: tokenSymbol, 
                decimals: tokenDecimals, 
                image: tokenImage, 
              },
            },
          });
        
          if (wasAdded) {
            console.log('Token added!');
          } else {
            console.log('Token has not been added');
          }
        } catch (error) {
          console.log(error);
        }
    }
    return (
      <DefaultLayout>
        <div className={darkClass("content-wrapper",theme)} style={{width:"100%"}}>
            <div className={`${darkClass("main-card-header",theme)} center-out`} style={{marginBottom:"0px",marginTop:"20px"}}>
                <h3>Claim Your BankX And XSD Tokens</h3>
                <h4>You must do a separate transaction</h4>
                <h4>for each token on each chain.</h4>
            </div>
            <div className={darkClass("main-card",theme)}>
                <div className={darkClass("main-card-inner",theme)}>
                    <div className="main-card-header">
                        {/* <h3>Claim</h3> */}
                        <div className="setting-wrapper">
                             </div>
                    </div>
                    <div className="main-card-body">
                       
                            {address && !loadingData && <div className={`${darkClass("side-info-box2",theme)} box-margin`}>
                                {
                                data.sort(compareCanClaim).map((airdrop) => (
                                    <div key={airdrop.name}><div style={{display: "flex"}}>
                                    <div className='col-8' style={{textAlign: 'left', lineHeight: 1}}>
                                            <label>{airdrop.ui_name} on AVAX</label>
                                            <br/>
                                            <h5>{Web3.utils.fromWei(airdrop.amount)}</h5>
                                            <button onClick={()=>addTokenFunction(airdrop.ui_name)} className={`button-add-token`}>
                                               {!claiming[airdrop.name] ?'Add token to a wallet': <img src="/images/preloader/white.svg" alt="" style={{width:"25px",height:"25px",marginRight:"5px"}}  />}
                                            </button>
                                        </div>
                                        <div  style={{textAlign: 'right'}} className='col-4'>
                                        
                                       {
                                       (Date.now()/1000) < airdrop.deadline && !airdrop.claimed &&
                                            <div>
                                               <button disabled={loading || airdrop.amount === "0" || claiming[airdrop.name] || !airdrop.canClaim} onClick={()=>handleClaim(airdrop)} className={`button-tab ${loading || airdrop.amount === "0" || !airdrop.canClaim?'':'button-tab-active'}`}>
                                                {!claiming[airdrop.name] ?'Claim': <img src="/images/preloader/white.svg" alt="" style={{width:"25px",height:"25px",marginRight:"5px"}}  />}
                                               </button>
                                            </div>
                                        }
                                        {airdrop.claimed && <h6>Claimed!</h6>}
                                        </div>
                                    </div>
                                    </div>
                                    ))
                                }
                            </div>}
                            {loadingData && <div className="btn-wrap">
                            <img src="/images/preloader/black.svg" alt="" style={{width:"25px",height:"25px",marginRight:"5px"}}  />
                            </div>}
                            {!address && <div className="btn-wrap">
                            <ConnectBtn/>
                            </div>}
                    </div>
                </div>
            </div>
            <div className={`${darkClass("main-card-header",theme)} center-out`} style={{marginBottom:"0px",marginTop:"20px"}}>
                <h4>BankX Token: {tokenAddressBankX}</h4>
                <h4>XSD Stablecoin: {tokenAddressXSD}</h4>
            </div>
        </div>
      </DefaultLayout>
    
  )
}
const mapStateToProps = (state) => ({
})
  
const mapDispatchToProps = (dispatch) => ({
})
  
  
export default connect(mapStateToProps,mapDispatchToProps)(Home);
